export enum UrlQueryParamName {
  IsOrySessionActive = 'isOrySessionActive',
  OrySSOLoginFinished = 'ssoLogin',
  OryFlow = 'flow',
  /**
   * When login flow was redirected to saml provider and after redirect back,
   * ory can add this query param to the url
   * it means that user email already exists in ORY with email and password account
   */
  OryOrganizationUserAlreadyExists = 'no_org_ui',
}

export enum UrlQueryParamValueBoolean {
  True = 'true',
}

export function buildUrlWithQueryParams({
  baseUrl,
  queryParams,
}: {
  baseUrl: string;
  queryParams?: Record<string, string>;
}): string {
  if (queryParams) {
    return `${baseUrl}?${new URLSearchParams(queryParams).toString()}`;
  }
  return baseUrl;
}

export function getUrlQueryParamValue({ paramName }: { paramName: string }): undefined | string | boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(paramName) || undefined;
  if (value === UrlQueryParamValueBoolean.True) {
    return true;
  }
  return value;
}

export function getCurrentURLWithoutQueryParams(): string {
  const url = new URL(window.location.href);
  url.search = '';
  return url.toString();
}

export function getCurrentBaseUrl(): string {
  const revisionUrl = process.env.REVISION_NAME ? '/' + process.env.REVISION_NAME : '';
  return window.location.origin + revisionUrl;
}

export function clearQueryStringOnCurrentUrl(): void {
  if (window?.history?.replaceState && window?.location?.pathname) {
    window.history.replaceState(null, '', window.location.pathname);
  }
}
